import createReducer from '../utils/createReducer';
import actions from '../actions/travelerSentimentsActions';

const initialState = {
    travelerSentiments: null
};

const actionHandlers = {
    [actions.FETCH_SENTIMENT_HIGHLIGHTS_SUCCESS](state, {payload}) {
        const {travelerSentiments} = payload;
        return {
            ...state,
            travelerSentiments
        };
    }
};

export default createReducer(actionHandlers, initialState);
